"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _reactToastify = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
var _constants = require("../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StyledToastContainer = (0, _material.styled)(_reactToastify.ToastContainer)({
  '&.Toastify__toast-container': {
    width: '590px'
  },
  '& .Toastify__toast-body': {
    alignItems: 'start',
    fontSize: '14px',
    fontWeight: 'bold',
    lineHeight: '28px'
  },
  '&  .Toastify__close-button': {
    display: 'none'
  },
  '& .Toastify__toast-icon': {
    display: 'none',
    marginRight: '12px',
    marginTop: '4px'
  },
  // styles for error toast
  '& .Toastify__toast--error': {
    backgroundColor: _constants.colors['main-color-cl-21'],
    padding: '6px 16px',
    '& .Toastify__toast-icon svg': {
      fill: _constants.colors['main-color-cl-08']
    },
    '& .Toastify__toast-body': {
      color: _constants.colors['main-color-cl-08']
    }
  }
});
const ToastWrapper = () => /*#__PURE__*/_react.default.createElement(StyledToastContainer, {
  position: "top-center",
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true
});
exports.ToastWrapper = ToastWrapper;